import { useState, useEffect } from 'react';

// Hook personalizado para obtener la posición del mouse en la ventana
export const useMousePosition = () => {
  // Estado para almacenar las coordenadas X e Y del mouse
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  
  useEffect(() => {
    // Función que actualiza el estado con la posición actual del mouse
    const updateMousePosition = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };
    
    // Se agrega el listener al evento 'mousemove' de la ventana
    window.addEventListener('mousemove', updateMousePosition);

    // Limpieza: se elimina el listener cuando el componente se desmonta
    return () => window.removeEventListener('mousemove', updateMousePosition);
  }, []); // El efecto solo se ejecuta una vez al montar el componente
  
  // Retorna la posición actual del mouse
  return mousePosition;
};